export default "__VITE_ASSET__CIwnactg__"